import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../common/html/checkbox'
import { Element } from '../../common/html/element'
import { REPORT_TYPE } from '../constant'
import classes from '../index.module.scss'
import {
  checkAll,
  selectBusinessCreditReportId,
  selectCheck,
  uncheckAll,
} from '../store/slice'
import ItemBusinessCreditReport from './ItemBusinessCreditReport'

const BusinessCreditReport = () => {
  const dispatch = useDispatch()

  const businessCreditReportId = useSelector(selectBusinessCreditReportId)
  const check = useSelector(selectCheck)

  const isCheckAll = businessCreditReportId.every((id) => check[id])
  const isCheckMinus = businessCreditReportId.some((id) => check[id])

  const onChange = (isCheck) => {
    if (isCheck) {
      dispatch(checkAll('businessCreditReport'))
    } else {
      dispatch(uncheckAll('businessCreditReport'))
    }
  }

  return (
    <>
      {!!businessCreditReportId.length && (
        <Element
          className="mt2"
          style={{ border: '1px solid #D5D5D5', borderBottom: 'hidden' }}
        >
          <Element
            className={classes.header}
            style={{ backgroundColor: '#F3F3F3' }}
          >
            <div className={`${classes.column1} dFlex alignItemsStart`}>
              <Checkbox
                onChange={onChange}
                checked={isCheckAll ? isCheckAll : isCheckMinus ? -1 : false}
                styleIcon={{ fontSize: 16 }}
              />
            </div>
            <Element
              style={{ fontSize: 14 }}
              className={`fw600 ${classes.column2}`}
            >
              {REPORT_TYPE.BUSINESS_CREDIT}
            </Element>
          </Element>
          {businessCreditReportId.map((id, index) => {
            return <ItemBusinessCreditReport key={id} id={id} index={index} />
          })}
        </Element>
      )}
    </>
  )
}

export default BusinessCreditReport
